import React from 'react';
import { Heart } from 'lucide-react';
import { useWishlist } from '@/store/dataStore';

export default function WishlistButton({ productId, className = '' }) {
  const { isFav, toggle } = useWishlist();
  const active = isFav(productId);
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(productId); }}
      aria-label={active ? 'Quitar de favoritos' : 'Agregar a favoritos'}
      className={`w-9 h-9 rounded-full flex items-center justify-center transition ${active ? 'bg-red-500 text-white shadow-md' : 'bg-white/90 text-slate-700 hover:bg-white hover:text-red-500 shadow'} ${className}`}
    >
      <Heart size={18} fill={active ? 'currentColor' : 'none'} />
    </button>
  );
}
